import React from 'react';
import Banner from '../Banner/Banner';
import Services from '../Services/Services'
import Works from '../Works/Works';

const Home = () => {
    return (
        <div>
            <Banner></Banner>
            <Services></Services>
            <Works></Works>
        </div>
    );
};

export default Home;